"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const DataProvider_1 = tslib_1.__importDefault(require("../DataProvider"));
var ScrileConnectManagerClientSubscriptionPlan;
(function (ScrileConnectManagerClientSubscriptionPlan) {
    ScrileConnectManagerClientSubscriptionPlan["STARTER"] = "STARTER";
    ScrileConnectManagerClientSubscriptionPlan["PROFESSIONAL"] = "PROFESSIONAL";
    ScrileConnectManagerClientSubscriptionPlan["ENTERPRISE"] = "ENTERPRISE";
})(ScrileConnectManagerClientSubscriptionPlan = exports.ScrileConnectManagerClientSubscriptionPlan || (exports.ScrileConnectManagerClientSubscriptionPlan = {}));
var ScrileConnectManagerDomainMigrationStatus;
(function (ScrileConnectManagerDomainMigrationStatus) {
    ScrileConnectManagerDomainMigrationStatus["NEW"] = "NEW";
    ScrileConnectManagerDomainMigrationStatus["WAITING_FOR_ACCESSIBLE"] = "WAITING_FOR_ACCESSIBLE";
    ScrileConnectManagerDomainMigrationStatus["MIGRATION_ERROR"] = "MIGRATION_ERROR";
})(ScrileConnectManagerDomainMigrationStatus = exports.ScrileConnectManagerDomainMigrationStatus || (exports.ScrileConnectManagerDomainMigrationStatus = {}));
class ScrileConnectManagerProvider extends DataProvider_1.default {
    get fragments() {
        return {
            ScrileConnectManagerClient: () => `
        ... on ScrileConnectManagerClient {
          id
          name
          email
          domains
          subscriptionPlan
        }
      `,
            ScrileConnectManagerDomainMigration: () => `
        ... on ScrileConnectManagerDomainMigration {
          domains
          status
        }
      `,
        };
    }
    clientDetails() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.query("scrileConnectManagerClientDetails", {}, this.getFragment("ScrileConnectManagerClient"));
        });
    }
    getDomainMigration() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.query("scrileConnectManagerDomainMigrationFind", {}, this.getFragment("ScrileConnectManagerDomainMigration"));
        });
    }
    createDomainMigration({ domains }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.mutate("scrileConnectManagerDomainMigrationCreate", { domains }, this.getFragment("ScrileConnectManagerDomainMigration"));
        });
    }
}
exports.ScrileConnectManagerProvider = ScrileConnectManagerProvider;
//# sourceMappingURL=ScrileConnectManagerProvider.js.map